import * as React from "react";
import * as Toggle from "@radix-ui/react-toggle";
import { Check } from "lucide-react";
import { cn } from "@/lib/utils";

/* Etichetta da scegliere, anche più di una: «Da dove arriva» (pacchetto del 29-10).
   Scelta = blu pieno con la spunta, così si capisce anche senza colori. */
export function ChoiceChip({ className, children, ...props }) {
  return (
    <Toggle.Root
      data-slot="choice-chip"
      className={cn(
        "group inline-flex h-10 items-center gap-1.5 rounded-sm border border-line-input bg-surface px-3 font-semibold text-ink",
        "transition-colors duration-150 ease-enter hover:bg-surface-2",
        "data-[state=on]:border-brand data-[state=on]:bg-brand data-[state=on]:text-on-brand",
        "focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand",
        "max-md:h-11",
        className,
      )}
      {...props}
    >
      <Check className="hidden size-3.5 group-data-[state=on]:block" strokeWidth={2.5} aria-hidden="true" />
      {children}
    </Toggle.Root>
  );
}
